import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Moment } from 'moment';


interface IImportRequestsContext {
    isLoading: boolean

    excelImportCount: number
    excelImportPageNr: number
    excelImportRequests: IRequest[]
    pageSize: number
    currentTab: string

    handleChangePage: (page: number) => void
    changeTab: (newTab: string) => void
}

export interface IRequest {
    requestId: string
    country: string
    fileName: string
    errors: string
    dateStart?: Moment
    dateEnd?: Moment
}

export let importRequestsContext = React.createContext({} as IImportRequestsContext);

let { Provider } = importRequestsContext;

let ImportRequestsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [pageSize] = useState(10);


    let [excelImportPageNr, setExcelImportPageNr] = useState(0);
    let [excelImportCount, setExcelImportCount] = useState(0);
    let [excelImportRequests, setExcelImportRequests] = useState<IRequest[]>([]);

    let [currentTab, setCurrentTab] = useState<string>('myexcelexport');

    useEffect(() => {
        getUserRequests();
    }, [])


    useEffect(() => {
        if (isLoading === false)
            getImportRequests(excelImportPageNr);
    }, [excelImportPageNr])


    let getUserRequests = async () => {
        try {
            setLoading(true);
            await getImportRequests(excelImportPageNr);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let getImportRequests = async (pageNr: number) => {
        try {

            let request = {
                pageNr,
                pageSize
            }

            let res = await axios.post('/api/ExcelImport/GetExcelImportRequests', request);;

            setExcelImportRequests(res.data.items);
            setExcelImportCount(res.data.recordCount);




        } catch (error) { }
    }

    let handleChangePage = (pageNr: number) => {

        setExcelImportPageNr(pageNr);

    }


    let changeTab = (newTab: string) => {
        setCurrentTab(newTab);
    }

    return (
        <Provider value={{
            isLoading,
            excelImportRequests,
            excelImportPageNr,
            pageSize,
            excelImportCount,
            currentTab,

            handleChangePage,
            changeTab
        }}>
            {children}
        </Provider>
    )
}

export default ImportRequestsProvider;